import { container } from 'tsyringe';
import { CampaignService } from '@/core/campaign/services/CampaignService';
import type { CurrentUser } from '@/core/user/models/CurrentUser';

export const deleteCampaignUseCase = async (currentUser: CurrentUser, input: string): Promise<void> => {
  await container.resolve<CampaignService>('CampaignService').delete(currentUser, input);
};
